import { useQuery } from '@tanstack/react-query';

import { companiesService, Company, FetchCompaniesRequest } from '@aslanpay/portal-common-lib';

const useFetchCompanies = (request: FetchCompaniesRequest, enabled = true) => {
  return useQuery<{ list: Company[] }, Error>(
    ['fetchCompanies', request],
    () => companiesService.fetchCompanies(request),
    {
      enabled,
    }
  );
};

export default useFetchCompanies;
